export default __webpack_public_path__ + "static/media/695.75f5725f.jpg";